import { createWeb3Modal, defaultWagmiConfig } from "@web3modal/wagmi/react";
import { defineChain } from "viem";
import { CHAIN_CONFIGS } from "../utils/constants";

// Project ID from WalletConnect Cloud
const projectId = "ac6818d713537310b1b5435748cba3f4"; // Using the same project ID as Shido Pools

// Define chains from our existing CHAIN_CONFIGS
const chains = Object.entries(CHAIN_CONFIGS).map(([key, config]) => {
  // Create array of RPC URLs with primary and fallbacks
  const rpcUrls = [config.rpcUrl];
  if (config.fallbackRpcUrls) {
    rpcUrls.push(...config.fallbackRpcUrls);
  }

  return defineChain({
    id: parseInt(config.chainId, 16),
    name: config.name,
    network: key,
    nativeCurrency: config.nativeCurrency || {
      name: "Ether",
      symbol: "ETH",
      decimals: 18,
    },
    rpcUrls: {
      default: { http: rpcUrls },
      public: { http: rpcUrls },
    },
    blockExplorers: config.explorerUrl
      ? {
          default: { name: config.name, url: config.explorerUrl },
        }
      : undefined,
  });
});

// Metadata for your dApp
const metadata = {
  name: "Shido Bridge",
  description: "Cross-chain token bridge for Shido Network",
  url: "https://bridge.shido.io",
  icons: ["/images/wshido.png"],
};

// Create wagmi config
export const wagmiConfig = defaultWagmiConfig({
  chains,
  projectId,
  metadata,
  enableWalletConnect: true,
  enableInjected: true,
  enableEIP6963: true,
  enableCoinbase: true,
});

// Initialize Web3Modal
export const initWeb3Modal = () => {
  createWeb3Modal({ 
    wagmiConfig, 
    projectId, 
    chains,
    themeMode: 'dark',
    themeVariables: {
      '--w3m-font-family': 'Inter, sans-serif',
      '--w3m-accent': '#001f59',
    },
    enableAnalytics: false,
    enableOnramp: false,
  });
};
